<!-- The template contains the HTML of our module  -->
<template>
  <!--
  Our module builds upon the 'wgu-module-card'
  it handles the integration into Wegue
  -->
  <wgu-module-card
    v-bind="$attrs"
    moduleName="ids-feature-info-module"
    class="ids-feature-info"
    :icon="icon"
  >

    <!-- Welcome Screen -->
    <v-card outlined v-if="Object.keys(featureProperties).length === 0">
      <v-img
        v-if="welcomeImageUrl"
        :src="welcomeImageUrl"
        height="200px"
      />

      <v-card-subtitle style="font-style: italic;">
        {{ $t('ids-feature-info-module.welcomeText') }}
      </v-card-subtitle>
    </v-card>

    <!-- Feature Info Property Table -->
    <wgu-property-table :properties="featureProperties" v-else />

  </wgu-module-card>
</template>
<script>
// the module card is a the template for a typical Wegue module
import ModuleCard from '../../../../src/components/modulecore/ModuleCard';
import PropertyTable from '../../../../src/components/infoclick/PropertyTable.vue'
import { WguEventBus } from '../../../../src/WguEventBus';
import LayerUtil from '../../../../src/util/Layer';
import { Mapable } from '../../../../src/mixins/Mapable';
import JsUtil from '../../../util/JsUtil.js';
import IdsCorpusLookup from '../../IdsCorpusLookup.js';

export default {
  name: 'ids-feature-info',
  // make sure to register the 'Mapable' mixin
  mixins: [Mapable],
  inheritAttrs: false,
  components: {
    'wgu-module-card': ModuleCard,
    'wgu-property-table': PropertyTable
  },
  props: {
    icon: { type: String, required: false, default: 'info' },
    welcomeImageUrl: { type: String, required: false }
  },
  data () {
    return {
      featureProperties: {},
      queryLinkText: 'Daten dieses Ortspunkts in der DGD',
      queryLinkSuffix: '(nur zur wissenschaftlichen Nutzung durch registrierte DGD-Nutzende)',
      lastSelectedFeat: null
    };
  },
  mounted () {
    WguEventBus.$on('ids-feature-info', clickedFeat => {
      this.stripProperties(clickedFeat);
    });

    // reset feature info results
    WguEventBus.$on('ids-before-new-locations-load', () => {
      this.featureProperties = {};
    });
  },

  created () {
    if (this.$vuetify.breakpoint.xs) {
      // sync visibility of sidebar with visibility of feature info
      WguEventBus.$on('ids-feature-info-module-visibility-change', () => {
        WguEventBus.$emit('sidebar-toggle');
      })
    }
  },

  methods: {
    onMapBound () {
      const declusterLayer = LayerUtil.getLayerByLid('ids-decluster-layer', this.map);
      const clusterLayer = LayerUtil.getLayerByLid('ids-result-layer', this.map);
      this.map.on('singleclick', (e) => {
        const clickedFeatures = this.map.getFeaturesAtPixel(e.pixel, {
          layerFilter: l =>
            l.get('lid') === declusterLayer.get('lid') ||
            l.get('lid') === clusterLayer.get('lid')
        });

        // list possible feature attributes
        if (clickedFeatures && clickedFeatures.length) {
          // decluster layer
          let clickedFeat = clickedFeatures[0];
          // location cluster layer
          const subFeats = clickedFeat.get('features');
          if (subFeats) {
            if (subFeats.length === 1) {
              clickedFeat = subFeats[0];
            } else {
              clickedFeat = null;
            }
          }

          if (clickedFeat) {
            // reset last selected feature
            if (this.lastSelectedFeat) {
              const originalFeat = this.lastSelectedFeat.get('originalFeat');
              if (originalFeat) {
                // original pendant of de-cluster feature
                originalFeat.set('ids-selected', false);
              } else {
                // single feat not in de-cluster
                this.lastSelectedFeat.set('ids-selected', false);
              }
              this.lastSelectedFeat = null;
            }

            // find the orig feature and store select state
            const originalFeat = clickedFeat.get('originalFeat');
            if (originalFeat) {
              // original pendant of de-cluster feature
              originalFeat.set('ids-selected', true);
            } else {
              // single feat not in de-cluster
              clickedFeat.set('ids-selected', true);
            }

            // preserve last selected feature
            this.lastSelectedFeat = clickedFeat;
          }

          this.stripAndShowProperties(clickedFeat);

          if (clickedFeat) {
            // ensure the sidebar with FeatureInfo result is visible
            WguEventBus.$emit('sidebar-toggle', true);
          }
        }
      });
    },
    /**
     *
     */
    stripAndShowProperties (feat) {
      if (!feat) {
        return;
      }

      const props = feat.getProperties();
      const clone = JsUtil.cloneObject(props);

      // avoid values from been showing in UI
      delete clone.geometry;
      delete clone.originalGeometry;
      delete clone.originalOlUid;
      delete clone.originalFeat;
      delete clone['ids-selected'];
      delete clone.Ortsteil;

      // adjust some known props, e.g. make links out of it
      for (const key in clone) {
        const val = clone[key];
        if (key === 'Korpus') {
          const corpusLabel = IdsCorpusLookup.getCorpusLabel(val);
          const link = IdsCorpusLookup.getCorpusLink(val);
          clone[key] = `<a href="${link}" target="_blank">${corpusLabel}</a>`;
        }
        if (key === 'DGD_url') {
          const dgdUrl = clone['DGD_url'];
          clone['Link'] = `<a href="${dgdUrl}" target="_blank">${this.queryLinkText}</a><br>${this.queryLinkSuffix}`;
          delete clone[key]; // remove original prop from UI
        }
      }

      this.featureProperties = clone;
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// app/ids/components/featureinfo/IdsFeatureInfoModuleWin.vue